import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Webhook } from "src/app/shared/models/focusDataModels/Webhook";
import { WebhookSubscription } from "src/app/shared/models/focusDataModels/WebhookSubscription";
import { Integrator } from "src/app/shared/models/integrator";
import { IntegratorVenue } from "src/app/shared/models/integrator-venue";

@Component({
	selector: "app-webhook-setup",
	templateUrl: "./webhook-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class WebhookSetupComponent implements OnInit {
	venueKey: number;
	venueIntegrators: Integrator[];

	webhooks: Webhook[];
	webhookSubscriptionNew = {
		integratorKey: undefined,
		webhookGuid: undefined,
		url: undefined,
	};
	webhookSubscriptions: WebhookSubscription[];

	webhookSelected: WebhookSubscription;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private focusData: FocusdataService,
		public imgCrop: ImageCropperService,
		public venueService: OOVenueService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.load(this.venueService.subscriptionVenue.value.key);
	}

	async load(venueKey: number) {
		this.webhookGet(venueKey);
		await this.webhookSubscriptionsGet(venueKey);
		await this.venueIntegratorsGet(venueKey);
		await this.parseWebhooks();
	}

	addWebhook() {
		this.webhookSelected = new WebhookSubscription({ venueKey: this.venueService.subscriptionVenue.value.key });
	}

	async parseWebhooks() {
		if (this.webhookSubscriptions?.length > 0) {
			for (let ws of this.webhookSubscriptions) {
				ws.integrator = this.venueIntegrators.find((i) => i.licenses.some((n) => n.key === ws.LicenseKey));
			}
		}
	}

	async webhookGet(venueKey) {
		const resp = await this.focusData.webhooksGet(venueKey);
		this.webhooks = resp.map((i) => {
			return new Webhook(i);
		});
	}

	async webhookSubscriptionsGet(venueKey) {
		const resp = await this.focusData.webhookGetSubscriptions(venueKey);

		this.webhookSubscriptions = resp.map((i) => {
			return new WebhookSubscription(i);
		});
	}

	async venueIntegratorsGet(venueKey) {
		const resp = await this.focuslink.integratorVenuesGet(venueKey);
		const integratorVenue: IntegratorVenue[] = resp.map((i) => {
			return new IntegratorVenue(i);
		});
		this.venueIntegrators = integratorVenue.map((i) => i.integrator);
	}

	async add(sourceTable) {
		this.webhookSubscriptions.push(
			new WebhookSubscription({
				venueKey: this.venueKey,
			})
		);
		sourceTable.initRowEdit(this.webhookSubscriptions[this.webhookSubscriptions.length - 1]);
	}

	async pause(rec: WebhookSubscription, active: boolean) {
		rec.Active = active;
		delete rec.Webhook;
		delete rec.integrator;
		await this.focusData.webhookPostSubscription(this.venueKey, rec);
		const webhook = this.webhookSubscriptions.find((i) => i.Guid === rec.Guid);
		webhook.Active = active;
	}

	async delete(rec: WebhookSubscription) {
		await this.confirmationService.confirm({
			message: "Are you sure you want to delete this webhook? It cannot be undone.",
			header: "Confirmation",
			icon: "pi pi-exclamation-triangle",
			accept: async () => {
				await this.focusData.webhookDeleteSubscription(this.venueKey, rec.LicenseKey, rec.WebhookGuid);
			},
			reject: (type) => {
				this.confirmationService.close();
			},
		});
	}

	async save() {
		const hook = this.webhookSubscriptions[this.webhookSubscriptions.length - 1];
		hook.Active = true;
		const integrator = this.venueIntegrators.find((i) => i.key === this.webhookSubscriptionNew.integratorKey);
		hook.LicenseKey = integrator.licenses.find((i) => i.type === "integrator").key;
		hook.WebhookGuid = this.webhookSubscriptionNew.webhookGuid;
		hook.WebhookUrl = this.webhookSubscriptionNew.url;
		hook.venueKey = this.venueKey;
		await this.focusData.webhookPostSubscription(this.venueKey, hook);
		hook.Webhook = this.webhooks.find((i) => i.Guid === hook.WebhookGuid);
		await this.parseWebhooks();
	}
}
